import * as React from 'react'
import { clamp } from '../service/util'
import { ISelection } from '../types'
import DocumentEventHandler from 'app/comp/document-event-handler'


export default class Selectable extends React.PureComponent<{
  text: string
  selection: ISelection
  onChangeSelection: (sel: ISelection) => void
}> {

  handleMouseDown = event => {
    const { text } = this.props

    const container = this.refs.container as any
    const x = event.clientX - container.offsetLeft
    const offset = clamp( Math.round(x / 10), 0, text.length)

    this.props.onChangeSelection([offset, offset])
  }

  handleMouseUp = () => {
    this.props.onChangeSelection(undefined)
  }

  handleMouseMove = event => {
    const { selection, text } = this.props

    if (!selection) {
      return
    }

    const container = this.refs.container as any
    const x = event.clientX - container.offsetLeft
    const offset = clamp( Math.round(x / 10), 0, text.length)

    this.props.onChangeSelection([selection[0], offset])
  }



  renderSelection() {
    const {
      selection
    } = this.props

    if (!selection) {
      return
    }

    const selectionStart = Math.min.apply(null, selection)
    const selectionEnd = Math.max.apply(null, selection)

    return (
      <div
        style={{
          backgroundColor: '#a3ccfe',
          height: 20,
          width: (selectionEnd - selectionStart) * 10,
          position: 'absolute',
          left: selectionStart * 10,
          top: 0
        }}
      />
    )
  }

  render() {
    const {
      text
    } = this.props

    return (
      <div ref="container" style={{ position: 'relative', userSelect: 'none', cursor: 'text' }}>

        <DocumentEventHandler
          onMouseDown={this.handleMouseDown}
          onMouseUp={this.handleMouseUp}
          onMouseMove={this.handleMouseMove}
        />

        {this.renderSelection()}
        <span style={{ fontSize: 20, zIndex: 10, position: 'relative', whiteSpace: 'pre' }}>{text}</span>
      </div>
    )
  }

}


// WEBPACK FOOTER //
// ./src/comp/selectable.tsx